import { FormGridContainer } from '@/components/shared/components/FormGridContainer/FormGridContainer';
import { TextFormField } from '@/components/shared/components/NewContextForms/TextFormField';
import { FieldVariant } from '@/components/shared/components/NewContextForms/types/FieldVariant';

export const AddAgentForm = () => {
  return (
    <FormGridContainer fieldVariant={FieldVariant.form} fullWidth>
      <TextFormField label={'AGENT_NAME'} name={'username'} />
      <TextFormField label={'AGENT_EMAIL'} name={'email'} />
    </FormGridContainer>
  );
};
